// extracted by mini-css-extract-plugin
export default {"root":"ListTabs_root__bfM0F","tab":"ListTabs_tab__9uD6v","--active":"ListTabs_--active__2awQl"};